import axios from 'axios'
import { Place } from '../../interfaces'

export const deletePlace = (place: Place) => {
  return axios.delete('/data/sadarbības_partnera_vieta/' + place.id)
}
